import React, { Fragment, useState } from 'react'
import { filter } from 'lodash'
import Table from 'UI/Table'

import { filteredVDCConsumption } from './Data'
import SubComponent from './SubComponent'

const VDCConsumptionSubTable = ({ row, filters, vdcs, columns }) => {
  return (
    <Fragment>
      <Table {...{
        data: filteredVDCConsumption(filters, row.original.vdcs),
        columns: filter(columns, column => (column.accessor !== filters.groupBy)),
        SubComponent: (row) => SubComponent({ row, filters, vdcs, columns, showVMs: true })
      }}
      />
    </Fragment>
  )
}

export default VDCConsumptionSubTable
